<template>
  <div class="banner">
    <DefSlider :settings="settings">
      <!--      :data-swiper-autoplay="+item?.timeout * 1000 || 5000"-->
      <div v-for="item in result.items" :key="item.id" class="swiper-slide">
        <div v-if="item.html">
          <DefInsertTildaSlider :result="item.html" />
        </div>
        <DefVideo v-else-if="item.video" :result="item.video" :loop="true" />
        <a v-else :href="item.link || item.detailPage" class="banner-link">
          <!--animation or picture-->
          <DefImg v-if="item.animation || item.picture" :result="item.animation || item.picture" />
          <!--pictures-->
          <DefPicture v-else-if="item.pictures" :result="item.pictures" />
        </a>
      </div>
    </DefSlider>
  </div>
</template>

<script lang="ts" setup>
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';
import DefInsertTildaSlider from '@components/Def/DefInsertTilda/DefInsertTildaSlider.vue';
import type { SwiperOptions } from 'swiper/types';
import { Autoplay } from 'swiper/modules';
import { IPicture, IPictures, IVideo } from '@/interfaces';
import { IAnimation } from '@/interfaces/IAnimation';

interface IResult {
  items: Array<{
    id: number;
    name: string;
    detailPage: string;
    article: number;
    link: string;
    picture?: IPicture;
    animation?: IAnimation;
    pictures?: IPictures;
    video?: IVideo;
    html?: string;
  }>;
}

const props = defineProps<{ result: IResult }>();

const settings: SwiperOptions = {
  slidesPerView: 1,
  modules: [Autoplay],
  autoplay: true,
};
</script>

<style lang="scss" scoped>
.banner {
  .swiper-slide {
    display: flex;
    align-items: center;
  }
  :deep(.def-video) {
    width: 100%;
  }
  .banner-link {
    display: block;
    width: 100%;
  }
}
</style>
